import React, { useState } from 'react';
// import GoogleMapReact from 'google-map-react';
import { withGoogleMap, GoogleMap, Marker,withScriptjs } from "react-google-maps"
import ReactTable from 'react-table';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import async from 'async';
import { connect } from "react-redux";
import _ from 'lodash';
import DateTime from 'react-datetime';
import moment from 'moment';
import numeral from 'numeral';
import { Form, FormInput } from 'react-form';

import Dropzone from 'react-dropzone';
import GMap from './GMap';


import { Select, FormGroup, Text, Textarea2, Checkbox, DatePicker } from 'components/FormElements';
import { required, validFixedLine, email, validPhoneLEC, equalTo, greaterThan, dateGreaterThanNowYear } from 'constants/InputErrors';

import Translate from 'util/IntlMessages';
import IncmsService from 'services/IncmsService';
import IncmsNewConn from 'services/IncmsNewConnService'
import { toggleAlertError, toggleLoading } from 'stores/actions';
import APPCONFIG from 'constants/Config';
import { injectIntl } from "react-intl";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


const DisabledInput = ( { children } ) => (
  <div style={{ padding: '6.5px 10px', backgroundColor: '#F0F0F0' }}>{children}</div>
)
const ShadowBox = ( { children, style } ) => (
  <div className="p-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px', ...style }}>
    {children}
  </div>
)


const MyGreatPlace = ({ text }) => <div style={{
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates
  position: 'absolute',
  width: 40,
  height: 40,
  left: -40 / 2,
  top: -40 / 2,

  border: '5px solid #f44336',
  borderRadius: 40,
  backgroundColor: 'white',
  textAlign: 'center',
  color: '#3f51b5',
  fontSize: 16,
  fontWeight: 'bold',
  padding: 4
}}>{text}</div>;

const numeralFormat = ( value ) => value ? numeral( value ).format( '0,0.[00]' ) : 0

class WorkRequest extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      errorUpload: {},
      accountData: {},
      accounts: [],
      activeAccount: _.find( _.get( props.channel, 'accounts', [] ), { active: true } ),
      movements: [],
      nationalities: [],
      genders:[ {id:"M", description:"M"}, { id:"F", description:"F"} ],
      personalIdTypes:[],
      communities:[],
      districts:[],
      regionCounties:[],
      zones:[],
      streets:[],
      preferedBillDeliveryModes:[],
      voltageLevels:[],
      appliances:[],
      applianceCollection:[],
      phases:[],
      readingFrecuencies:[],
      premiseApplicationCapacities:[],
      premiseBuildingTypes:[],
      premiseSubActivities:[],
      premiseActivities:[],
      premiseCategories:[],
      premiseTypes:[],
      supplyTypes:[],
      appliances:[],
      customerTypes:[],
      documents:{},
      meterModalOpened: false,
      activityModalOpened: false,
      billModalOpened: false,
      billModalLECOpened: false,
      collectionModalOpened: false,
      mapModalOpened: false,
      tokenModalOpened: false,
      tokenModalLECOpened: false,
      movementFilterDateFrom: null,
      movementFilterDateTo: null,
      movementFilterType: null,
      outageInArea: false,
      latitude: 6.3192201,
      longitude: -10.806167 ,
      lecLat: 6.3192201,
      lecLng:-10.806167,
      nationality:'PD047',
      documentsGroupId: 1,
      defaultZoom:15,
      documentsGroup:[ {id:1, description: <Translate id="NationalIdAndProof"/>}, { id:2, description: <Translate id="TaxIdentification"/>} ],

    };
    this.submitForm = this.submitForm.bind( this );
    this.getData = this.getData.bind( this );
    this.addAppliance = this.addAppliance.bind( this );
    this.rmAppliance = this.rmAppliance.bind( this );
    this.handleAppliance = this.handleAppliance.bind( this );
    this.addMarker = this.addMarker.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.sendFileMessage = this.sendFileMessage.bind(this);
    this.handleZoom = this.handleZoom.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

  componentDidMount() {
    this.getDataInitial()
  }

  getGeoData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      regionCountiesData: this.getCountries.bind( this ),
      districtsData: this.getProvinces.bind( this ),
      zonesData: this.getCities.bind( this ),
      communitiesData: this.getLocalities.bind( this ),
      streetsData: this.getStreet.bind( this ),
     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        regionCounties: results.regionCountiesData,
        districts: results.districtsData,
        zones: results.zonesData,
        communities: results.communitiesData,
        streets: results.streetsData,
      } )
    } )

  }


  getSubActivityData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      premiseSubActivitiesData: this.getSubActivities.bind( this ),

     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        premiseSubActivities: results.premiseSubActivitiesData,

      } )
    } )

  }


  getPremiseTypesCategoriesData (){

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );
    async.parallel( {
      premiseCategoriesData: this.getPremiseTypesCategories.bind( this ),

     
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      this.setState( {
        premiseCategories: results.premiseCategoriesData,

      } )
    } )

  }

  getDataInitial() {
    const { activeAccount } = this.state;
    // if( !activeAccount ) return;
    // console.log ( "ACTIVE ACCOUNT ", this.props.activeAccount );

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {

      supplyTypesData: this.getSupplyTypes.bind( this ),

      nationalitiesData: this.getCustomerNationalities.bind( this ),

      regionCountiesData: this.getCountries.bind( this ),

    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      let accounts = _.get( results.accountData, 'OtherAccounts', [] ) || [];
      accounts = _.map( accounts, item => ( { id: item.OtherAccount, account: item.OtherAccount } ) );
      this.setState( {
        accountData: results.accountData,
        accounts: activeAccount ? [activeAccount, ...accounts] : [],
        //outageInArea: !!_.get( results.outageInArea, 'imsOutageInArea' ),
        supplyTypes: results.supplyTypesData,
        nationalities:  _.orderBy(results.nationalitiesData, ['description'],['asc']) ,
        regionCounties: results.regionCountiesData,


      } )
    } )
  }



  getData() {
    const { activeAccount } = this.state;
    // if( !activeAccount ) return;

    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    async.parallel( {
      appliancesData: this.getAppliances.bind( this ),
      //accountData: this.getAccountData.bind( this ),
      //outageInArea: this.getOutageInArea.bind( this ),
      supplyTypesData: this.getSupplyTypes.bind( this ),

      nationalitiesData: this.getCustomerNationalities.bind( this ),
      //gendersData: this.getOutageInArea.bind( this ),
      personalIdTypesData: this.getCustomerDocumentTypes.bind( this ),
      regionCountiesData: this.getCountries.bind( this ),
      //districtsData: this.getProvinces.bind( this ),
      //zonesData: this.getCities.bind( this ),
      //communitiesData: this.getLocalities.bind( this ),
      //streetsData: this.getStreet.bind( this ),
      preferedBillDeliveryModesData: this.getBillDispatch.bind( this ),
      voltageLevelsData: this.getVoltage.bind( this ),
      phasesData: this.getServicePhase.bind( this ),
      readingFrecuenciesData: this.getReadingFrequency.bind( this ),
      premiseApplicationCapacitiesData: this.getApplicationCapacity.bind( this ),
      premiseBuildingTypesData: this.getBuildings.bind( this ),
      
      premiseActivitiesData: this.getActivities.bind( this ),
      //premiseCategoriesData: this.getPremiseTypesCategories.bind( this ),
      premiseTypesData: this.getPremiseTypes.bind( this ),
      customerTypesData: this.getCustomerTypes.bind( this ),
    }, ( error, results ) => {
      toggleLoading( false );
      if( error ) return toggleAlertError( error );

      let accounts = _.get( results.accountData, 'OtherAccounts', [] ) || [];
      accounts = _.map( accounts, item => ( { id: item.OtherAccount, account: item.OtherAccount } ) );
      this.setState( {
        appliances: results.appliancesData,
        accountData: results.accountData,
        accounts: activeAccount ? [activeAccount, ...accounts] : [],
        //outageInArea: !!_.get( results.outageInArea, 'imsOutageInArea' ),
        movements: _.get( results.accountData, 'Movements', [] ),
        supplyTypes: results.supplyTypesData,
        nationalities:  _.orderBy(results.nationalitiesData, ['description'],['asc']) ,
        personalIdTypes: results.personalIdTypesData,
        regionCounties: results.regionCountiesData,
        //districts: results.districtsData,
        //zones: results.zonesData,
        //communities: results.communitiesData,
        //streets: results.streetsData,
        preferedBillDeliveryModes: results.preferedBillDeliveryModesData,
        voltageLevels: results.voltageLevelsData,
        phases: results.phasesData,
        readingFrecuencies: results.readingFrecuenciesData,
        premiseApplicationCapacities: results.premiseApplicationCapacitiesData,
        premiseBuildingTypes: results.premiseBuildingTypesData,
        //premiseSubActivities: results.premiseSubActivitiesData,
        premiseActivities: results.premiseActivitiesData,
        //premiseCategories: results.premiseCategoriesData,
        premiseTypes: results.premiseTypesData,
        customerTypes: results.customerTypesData

      } )
    } )
  }

  getAccountData( cb ) {
    IncmsService.getClientFolderData( this.state.activeAccount.account, this.props.locale ? this.props.locale.locale : 'en' )
      .then( ( response ) => {
        if( response.errors ) return cb( response.errors );
        cb( null, response.data )
      } )
  }

  getOutageInArea( cb ) {
    IncmsService.getClientFolderOutageArea( this.state.activeAccount.account )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getSupplyTypes( cb ) {
    IncmsNewConn.getSupplyTypes()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerTypes( cb ) {
    IncmsNewConn.getCustomerTypes(this.state.supplyType)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerNationalities( cb ) {
    IncmsNewConn.getCustomerNationalities()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCustomerDocumentTypes( cb ) {
    IncmsNewConn.getCustomerDocumentTypes( 
      this.state.customerType, 
      this.state.supplyType
    )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getBillDispatch( cb ) {
    IncmsNewConn.getBillDispatch( this.state.supplyType )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getAppliances( cb ) {
    IncmsNewConn.getAppliances( this.state.supplyType )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getDocuments( cb ) {
    IncmsNewConn.getDocuments()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getCountries( cb ) {
    IncmsNewConn.getCountries()
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getProvinces( cb ) {
    IncmsNewConn.getProvinces(this.state.regionCounty)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getCities( cb ) {
    IncmsNewConn.getCities( this.state.regionCounty, this.state.district )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }


  getLocalities( cb ) {
    IncmsNewConn.getLocalities( 
      this.state.regionCounty,
      this.state.zone,
      this.state.district,
       )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getStreet( cb ) {
    IncmsNewConn.getStreet(
      this.state.regionCounty,
      this.state.zone,
      this.state.district,
      this.state.community

    )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getPremiseTypes( cb ) {
    IncmsNewConn.getPremiseTypes( this.state.supplyType)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  getPremiseTypesCategories( cb ) {
    IncmsNewConn.getPremiseTypesCategories(this.state.supplyType, this.state.premiseType)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getActivities( cb ) {
    IncmsNewConn.getActivities( this.state.supplyType )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getSubActivities( cb ) {
    IncmsNewConn.getSubActivities( this.state.supplyType, this.state.premiseActivity)
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getBuildings( cb ) {
    IncmsNewConn.getBuildings( this.state.supplyType )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getApplicationCapacity( cb ) {
    IncmsNewConn.getApplicationCapacity( this.state.supplyType  )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getReadingFrequency( cb ) {
    IncmsNewConn.getReadingFrequency( this.state.supplyType  )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getServicePhase( cb ) {
    IncmsNewConn.getServicePhase( this.state.supplyType  )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }
  getVoltage( cb ) {
    IncmsNewConn.getVoltage( this.state.supplyType  )
      .then( ( response ) => {
        if( response.errors ) return cb();
        cb( null, response.data )
      } )
  }

  addAppliance(e){
    this.setState ( prevState => (   { applianceCollection: [...prevState.applianceCollection, { } ] })   );
  }


  rmAppliance(index){
    let applianceCollection = [...this.state.applianceCollection];
    applianceCollection.splice(index, 1) ;
    this.setState ( { applianceCollection});
  }

  addMarker(e){

    this.setState ( { latitude: e.latLng.lat() , longitude: e.latLng.lng()  });

  }

  handleDate(name,value){
    this.setState({[name]: value})
  }

  handleZoom( value ) {
    this.setState({defaultZoom:value});
  }

  handleAppliance(value, i, fieldName) {
    let applianceCollection = [...this.state.applianceCollection];
    applianceCollection[i][fieldName] = value;
    this.setState({ applianceCollection });

    //const data = {}
    //data[fieldName] = value;
    //this.setState ( data );
    //this.state.applianceCollection[index]=data;
    //this.setState ( { applianceCollection: [...this.state.applianceCollection, {}] });


  }
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  submitForm( data ) {
    //const { onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;
    const { toggleLoading, toggleAlertError, onReloadChannel, onClose } = this.props;
    const { documentsGroupId } = this.state;
    toggleLoading( true );
    const dataToSend={};
    dataToSend.supplyTypeId= data.supplyType.toString();
    dataToSend.supplyTypeContractMask = this.state.supplyTypeContractMask.toString();
    dataToSend.supplyTypeDescription = '';
    dataToSend.customerId = this.props.activeAccount ? this.props.activeAccount.idCustomer.toString() : null; //50071229;
    dataToSend.firstName = data.firstName;
    dataToSend.middleName = data.middleName;
    dataToSend.surname = data.surname;
    dataToSend.birthday = data.dateOfBirth ? moment( data.dateOfBirth ).format('YYYY-MM-DD')  :  moment(this.state.dateOfBirth).format('YYYY-MM-DD') ;
    dataToSend.gender = data.gender;
    dataToSend.idIssueDate = data.issueDate ?  moment(data.issueDate).format('YYYY-MM-DD')  :  moment(this.state.issueDate).format('YYYY-MM-DD')  ;
    dataToSend.idExpiryDate = data.expiryDate ?  moment(data.expiryDate).format('YYYY-MM-DD')  :  moment(this.state.expiryDate).format('YYYY-MM-DD')  ;
    dataToSend.docType = data.personalIdType.toString();
    dataToSend.docId = data.personalIdNumber.toString();
    dataToSend.idDescription=''; //Tax Identification Number,
    dataToSend.nationalityId = data.nationality;
    dataToSend.nationalityDescription= '';// Liberia,
    dataToSend.email = data.primaryEmail,
    dataToSend.mobileNumber = data.mobileNumber.toString();
    dataToSend.phone2 = data.phone2;
    dataToSend.phone3 = data.phone3;
    dataToSend.fax = data.fax;
    dataToSend.facebookUser = data.facebookName;
    dataToSend.twitterUser = data.twitterName;

    dataToSend.countryCode = data.regionCounty.toString(); //1
    dataToSend.provinceId = data.district.toString(); //1
    dataToSend.cityId = data.zone.toString();
    dataToSend.localityId = data.community.toString();
    dataToSend.streetId = data.street.toString();

    dataToSend.landmark = data.premiseLandmark;
    dataToSend.poleNumber = data.premisePoleNumber;
    dataToSend.streetName = ''; // what;
    dataToSend.district = ''; // what;
    dataToSend.locality = data.community;
    dataToSend.provinceName = ''; ///: pn;
    dataToSend.countryName = ''; // what
    dataToSend.cityName = ''; //;
    dataToSend.phase = data.phase; 
    dataToSend.tension = data.voltageLevel.toString();
    dataToSend.readingFrequency = data.readingFrecuency.toString();

    dataToSend.serviceCountryCode = data.regionCounty.toString(); //2
    dataToSend.serviceProvinceId = data.district.toString();
    dataToSend.serviceCityId = data.zone.toString();
    dataToSend.serviceLocalityId = data.community.toString();
    dataToSend.servicePoleNumber = data.premisePoleNumber;
    dataToSend.serviceStreetId = data.street.toString();
    
    dataToSend.serviceLandmark = data.premiseLandmark;
    dataToSend.serviceStreetName = '';
    dataToSend.serviceLocality = data.community.toString();
    dataToSend.serviceProvinceName = '';
    dataToSend.serviceCountryName = '';
    dataToSend.serviceCityName = '';
    dataToSend.propertyPremiseName = data.premiseName;
    dataToSend.propertyPoleNumber = data.premisePoleNumber;
    dataToSend.propertyPremiseType = data.premiseType.toString();
    dataToSend.propertyPromiseCategory = data.premiseCategory.toString() ;
    dataToSend.propertyPhase = data.phase.toString() ;
    dataToSend.propertyX = this.state.latitude;
    dataToSend.propertyY = this.state.longitude;
    dataToSend.sendSMS = data.sendSMS ? data.sendSMS : false ;
    dataToSend.distributionMode = data.preferedBillDeliveryMode.toString();
    dataToSend.billCopies = data.billCopies.toString();
    dataToSend.activity = data.premiseActivity.toString();
    dataToSend.subActivity = data.premiseSubActivity.toString();
    dataToSend.buildingType = data.premiseBuildingType.toString();
    dataToSend.applicationCapacity = data.premiseApplicationCapacity.toString();

    dataToSend.appliances = _.map( this.state.applianceCollection, ( coll ,idc ) => {  
      return {
      "description": coll['DeviceCode'].toString(),
      "deviceCode": coll['DeviceCode'].toString(),
      "power": coll['DevicePower'].toString(),
      "number": coll['DeviceNumber'].toString(),
    }     }) ;

    dataToSend.documents=[];

    const documentKeyToSend = [ 
      "documentStatus",
      "documentType",
      "storageFilename",
      "originalFilename",
      "contentType",
      "description",
      "creationDate",
      "contentClass"
    ];

    if (_.hasIn( this.state.documents, 'CD001') && (documentsGroupId === 1 ))
      dataToSend.documents.push( _.pick( this.state.documents['CD001'], documentKeyToSend  ));
    if (_.hasIn( this.state.documents, 'CD017') && (documentsGroupId === 1 ))
      dataToSend.documents.push( _.pick( this.state.documents['CD017'], documentKeyToSend  ) );
    
    if (_.hasIn( this.state.documents, 'CD007') && (documentsGroupId === 2 ))
      dataToSend.documents.push( _.pick( this.state.documents['CD007'], documentKeyToSend  ) );

    if (_.hasIn( this.state.documents, 'CD018'))
      dataToSend.documents.push( _.pick( this.state.documents['CD018'], documentKeyToSend  ) );
    if (_.hasIn( this.state.documents, 'CD019'))
      dataToSend.documents.push( _.pick( this.state.documents['CD019'], documentKeyToSend  ) );

    
    IncmsNewConn.save( dataToSend ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) 
         return toggleAlertError( response.errors );

     toggleAlertError( `Work Request Code : ${response.data.requestData.requestId || '---'}`, response.data.requestData.requestId );
     
     onReloadChannel( );
     onClose()
    

    } )
  }

   sendFileMessage = ( documentType, file ) => {
    const { toggleLoading,toggleAlertError, externalApiUrl } = this.props;
    const {documents, errorUpload} = this.state;
    toggleLoading(true)

    IncmsNewConn.sendFile( externalApiUrl, { file } )
      .then( ( response ) => {
        toggleLoading(false)
        if( response.errors ) {
          toggleAlertError( response.errors )

          errorUpload[ documentType ] = true;
          this.setState( errorUpload );
          //return false

        }
        const wrdocument = response.data;
        if (wrdocument){
          wrdocument.documentType = documentType;
          documents[documentType] = wrdocument;
          this.allDocs = documents;
          errorUpload[ documentType ] = false;
          this.setState( errorUpload );
        } else {
          errorUpload[ documentType ] = true;
          this.setState( errorUpload );
        }
        
        //return true;
      } )

  }

  handleChange = (current, newValue) => {
    console.log("NEW VLUE")
    if (!!newValue)
    this.props.setTab(newValue)
  };

  render() {
    const {
      errorUpload,
      accountData, 
      accounts, 
      activeAccount, 
      movements, 
      movementFilterDateFrom, 
      movementFilterDateTo,
      nationalities,
      nationality,
      genders,
      gender,
      personalIdTypes,
      personalIdType,
      communities,
      community,
      districts,
      district,
      regionCounties,
      regionCounty,
      streets,
      street,
      zones,
      zone,
      customerTypes,
      customerType,
      preferedBillDeliveryModes,
      preferedBillDeliveryMode,
      voltageLevels,
      voltageLevel,
      phases,
      phase,
      readingFrecuencies,
      readingFrecuency,
      premiseApplicationCapacities,
      premiseApplicationCapacity,
      premiseBuildingTypes,
      premiseBuildingType,
      premiseSubActivities,
      premiseSubActivity,
      premiseActivities,
      premiseActivity,
      premiseCategories,
      premiseCategory,
      premiseTypes,
      premiseType,
      supplyType,
      supplyTypeId,
      supplyTypes,
      appliances,
      DeviceCode,
      DevicePower,
      DeviceNumber,
      applianceCollection,
      movementFilterType, 
      expiryDate,
      issueDate,
      dateOfBirth,
      longitude,
      latitude,
      lecLng,
      lecLat,
      defaultZoom,
      mobileNumber,
      firstName,
      middleName,
      surname,
      personalIdNumber,
      primaryEmail,
      confirmEmail,
      premiseName,
      premiseLandmark,
      premisePoleNumber,
      billCopies,
      phone2,
      phone3,
      facebookName,
      twitterName,
      note,
      fax,
      documentsGroup,
      documentsGroupId,
      documents,
      currentZoom,
      meterModalOpened, activityModalOpened,
      billModalOpened, billModalLECOpened, collectionModalOpened, tokenModalOpened, tokenModalLECOpened, outageInArea, mapModalOpened
    } = this.state;
    
    const { dateFormat, externalCodes,googleMapKey, uploadFile, selectedTab } = this.props;
    const meters = _.get( accountData, 'ServicesList[0].MeterNumbers', [] );
    const contacts = _.get( accountData, 'Contact', [] );
    const movementTypes = _.chain( _.get( accountData, 'Movements', [] ) )
      .map( item => ( { id: item.MovementType, name: item.MovementType } ) ).uniqBy( 'id' ).value();
    
    
    const MyMapComponent = withScriptjs( withGoogleMap( (props) =>{
      const [currentZoom, setCurrentZoom] = useState(15);//default

      function handleZoomChanged() {
        
        props.handleZoom(this.getZoom());
        
      } 
    
    return (
      <GoogleMap
        onClick={props.addMarker}
        defaultZoom={props.defaultZoom}
        defaultCenter={{ lat: props.lat, lng: props.lng }}
        onZoomChanged={handleZoomChanged}
      >
        <Marker position={{ lat: props.lat, lng: props.lng}} />
      </GoogleMap>
    )
    }
    ))
    
    return (
      <div className="client-folder mb-5">
         <Form onSubmit={this.submitForm}
              defaultValues={{ 
                supplyType: supplyTypeId,
                nationality: nationality,
                customerType: customerType,
                mobileNumber: mobileNumber,
                fax:fax,
                phone2: phone2,
                phone3: phone3,
                facebookName: facebookName,
                twitterName: twitterName,
                note: note,
                firstName: firstName,
                middleName: middleName,
                surname: surname,
                dateOfBirth:dateOfBirth,
                nationality:nationality,
                expiryDate: expiryDate,
                personalIdNumber: personalIdNumber,
                issueDate: issueDate,
                personalIdType: personalIdType,
                customerType: customerType,
                gender:gender,
                primaryEmail: primaryEmail,
                confirmEmail: confirmEmail,
                regionCounty: regionCounty,
                district:district,
                zone: zone,
                community: community,
                street: street,
                premiseName: premiseName,
                premiseType: premiseType,
                premiseCategory: premiseCategory,
                premiseActivity: premiseActivity,
                premiseSubActivity: premiseSubActivity,
                premiseBuildingType: premiseBuildingType,
                premiseApplicationCapacity: premiseApplicationCapacity,
                premiseLandmark: premiseLandmark,
                premisePoleNumber: premisePoleNumber,
                readingFrecuency: readingFrecuency,
                phase: phase,
                preferedBillDeliveryMode:preferedBillDeliveryMode,
                billCopies:billCopies,
                documentsGroupId: documentsGroupId,
                voltageLevel:voltageLevel,
                
              }}
              onValidationFail={() => {
                this.props.toggleAlertError( this.props.intl.formatMessage( { id: 'formValidationErrors' } ));
              }}
              validate={( values ) =>  {
                const VALIDATIONS =  {
                mobileNumber: required( values.mobileNumber ) ? required( values.mobileNumber ) : validPhoneLEC( values.mobileNumber ),
                firstName: required( values.firstName ),
               
                middleName: required( values.middleName ),
                surname: required( values.surname ),
                dateOfBirth: required( values.dateOfBirth ) ? required( values.dateOfBirth )  : dateGreaterThanNowYear(values.dateOfBirth,18),
                nationality: required( values.nationality ),
                expiryDate: required( values.expiryDate ) ? required( values.expiryDate )  : greaterThan(values.expiryDate, values.issueDate, 'Issue Date'),
                personalIdNumber: required( values.personalIdNumber ),
                issueDate: required( values.issueDate ),
                personalIdType: required( values.personalIdType ),
                customerType: required( values.customerType ),
                supplyType: required( values.supplyType ),
                gender: required( values.gender ),
                primaryEmail: required( values.primaryEmail ) ? required( values.primaryEmail ) : email(values.primaryEmail),
                confirmEmail: required( values.confirmEmail ) ? required( values.confirmEmail ) : equalTo(values.primaryEmail, values.confirmEmail, 'primaryEmail'  ),
                // note: required( values.note ),
                regionCounty: required( values.regionCounty ),
                district: required( values.district ),
                zone: required( values.zone ),
                community: required( values.community ),
                street: required( values.street ),
                premiseName: required( values.premiseName ),
                premiseType: required( values.premiseType ),
                premiseCategory: required( values.premiseCategory ),
                premiseActivity: required( values.premiseActivity ),
                premiseSubActivity: required( values.premiseSubActivity ),
                premiseBuildingType: required( values.premiseBuildingType ),
                premiseApplicationCapacity: required( values.premiseApplicationCapacity ),
                premiseLandmark: required( values.premiseLandmark ),
                premisePoleNumber: required( values.premisePoleNumber ),
                readingFrecuency: required( values.readingFrecuency ),
                voltageLevel: required( values.voltageLevel),
                phase: required( values.phase ),
                preferedBillDeliveryMode: required( values.preferedBillDeliveryMode ),
                billCopies: required( values.billCopies ),
                } 

                if (values.phone2 )  VALIDATIONS.phone2 = validPhoneLEC( values.phone2 )
                if (values.phone3 )  VALIDATIONS.phone3 = validPhoneLEC( values.phone3 )
                if (values.fax )  VALIDATIONS.fax = validPhoneLEC( values.fax )

                if (VALIDATIONS){
                  
                }

                return VALIDATIONS;
                }

                
              }

        >
        {( { getValue, setValue, removeValue, submitForm, getFormState } )=> 
        <form onSubmit={submitForm}>
        <div className="pb-0">
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="work_requests"/>
              </h5>
            </div>

          </div>
        </div>

        <Tabs value={selectedTab}  aria-label="Work Request" onChange={this.handleChange}>
          <Tab label={<Translate id="NewConnection"/>}  />
          {this.props.activeAccount &&
          <Tab label={<Translate id="ChangeOwnership"/>} />
          }
          {this.props.activeAccount &&
          <Tab label={<Translate id="ChangeTenant"/>} />
          }
          {this.props.activeAccount &&
          <Tab label={<Translate id="PowerUpgrade"/>} />
          }
        </Tabs>
       
        <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="NewConnection"/>
              </h5>
            </div>
            <div className="col-md-auto d-flex align-items-center">

            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
              <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="supplyType"/>
                    </label>
                    <Select
                        field="supplyType"
                        clearable={false}
                        onChange={( value ) => {
                          //const supplyType = _.find( supplyTypes, { id: value } );
                          //if( supplyType ) {
                            const objSupply = _.find(supplyTypes, { 'id': value} );
                            //console.log( objSupply );
                            this.setState( { supplyType: objSupply.contractMask,supplyTypeId: value, supplyTypeContractMask: objSupply.contractMask }, this.getData )
                          //}
                        }}
                        options={supplyTypes}
                        className="form-control"
                        labelKey="description"
                        //valueKey="contractMask"
                        searchable={true}
                        value={supplyType}
                      />
                  </FormGroup>
                </div>
                <div className="col-md-2">
                  <FormGroup>
                    <label>
                      <Translate id="customerType"/>
                    </label>
                    <Select
                        field="customerType"
                        clearable={false}
                        onChange={( value ) => {
                          //const customerType = _.find( customerTypes, { id: value } );
                          //if( customerType ) {
                          this.setState( { customerType: value }, this.getData )
                          //}
                        }}
                        options={_.filter(customerTypes,{id:'TC001'})}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={customerType}
                      />
                  </FormGroup>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="customerData"/>
              </h5>
            </div>
            <div className="col-md-auto d-flex align-items-center">
 
            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
              
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="firstName"/>
                    </label>
                    <Text field="firstName" className="form-control"  onChange={( value ) => {  this.setState( { firstName: value }) }}/>
                  </FormGroup>
                </div>

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="middleName"/>
                    </label>
                    <Text field="middleName" className="form-control" onChange={( value ) => {  this.setState( { middleName: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="surname"/>
                    </label>
                    <Text field="surname" className="form-control" onChange={( value ) => {  this.setState( { surname: value }) }}/>
                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="personalIdType"/>
                    </label>
                    <Select
                        field="personalIdType"
                        clearable={false}
                        onChange={( value ) => {  this.setState( { personalIdType: value }) }}
                        options={personalIdTypes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={personalIdType}
                      />
                  </FormGroup>
                </div>

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="nationality"/>
                    </label>
                      <Select
                        field="nationality"
                        clearable={false}
                        onChange={( value ) => {
                          //const nationality = _.find( nationalities, { id: value } );
                          //if( nationality ) {
                            this.setState( { nationality: value } )
                          //}
                        }}
                        options={nationalities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={nationality}
                      />
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="personalIdNumber"/>
                    </label>
                    <Text field="personalIdNumber" className="form-control" onChange={( value ) => {  this.setState( { personalIdNumber: value }) }}/>
                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="issueDate"/>
                    </label>
                    <FormInput field="issueDate">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                      <div className="input-group">
                      <DateTime
                            onChange={(value)=>{ setValue(value);handleDate("issueDate",   value) }}
                            onBlur={setTouched}
                            value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) :  moment(  issueDate).format( dateFormat || 'DD/MM/YYYY' )}
                            field="issueDate"
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                            closeOnSelect={true}
                            inputProps={{
                              className: 'form-control bg-color-white',
                              readOnly: false
                            }}
                        />
                      </div>
                    }
                    </FormInput>

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="expiryDate"/>
                    </label>

                    <FormInput field="expiryDate">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                      <div className="input-group">
                      <DateTime
                            onChange={(value)=>{ setValue(value);handleDate("expiryDate", value ) }}
                            onBlur={setTouched}
                            value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) :  moment(  expiryDate).format( dateFormat || 'DD/MM/YYYY' )}
                            field="expiryDate"
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                            closeOnSelect={true}
                            inputProps={{
                              className: 'form-control bg-color-white',
                              readOnly: false
                            }}
                        />
                      </div>
                    }
                    </FormInput>

                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="dateOfBirth"/>
                    </label>

                    <FormInput field="dateOfBirth">
                    {( { setValue, getValue, setTouched, handleDate = this.handleDate } ) =>
                      <div className="input-group">
                      <DateTime
                            onChange={(value)=>{ setValue(value);handleDate("dateOfBirth", value ) }}
                            onBlur={setTouched}
                            value={getValue() ? moment( getValue() ).format( dateFormat || 'DD/MM/YYYY' ) :  moment(  dateOfBirth).format( dateFormat || 'DD/MM/YYYY' )}
                            field="dateOfBirth"
                            dateFormat={'YYYY-MM-DD'}
                            timeFormat={false}
                            closeOnSelect={true}
                            inputProps={{
                              className: 'form-control bg-color-white',
                              readOnly: false
                            }}
                        />
                      </div>
                    }
                    </FormInput>

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="gender"/>
                    </label>
                    <Select
                        field="gender"
                        clearable={false}
                        onChange={( value ) => {
                          //const gender = _.find( genders, { id: value } );
                          //if( gender ) {
                            this.setState( { gender: value } )
                          //}
                        }}
                        options={genders}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={gender}
                      />
                  </FormGroup>
                </div>
              </div>

            </div>

          </div>
        </div>

        <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="customerContact"/>
              </h5>
            </div>
            <div className="col-md-auto d-flex align-items-center">

            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="primaryEmail"/>
                    </label>
                    <Text field="primaryEmail" className="form-control" onChange={( value ) => {  this.setState( { primaryEmail: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="confirmEmail"/>
                    </label>
                    <Text field="confirmEmail" className="form-control" onChange={( value ) => {  this.setState( { confirmEmail: value }) }}/>
                  </FormGroup>
                </div>


              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="mobileNumber"/>
                    </label>
                    <Text field="mobileNumber" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { mobileNumber: value }) }}/>

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="phone2"/>
                    </label>
                    <Text field="phone2" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { phone2: value }) }}/>
                  </FormGroup>
                </div>
              </div>

              <div className="row">

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="phone3"/>
                    </label>
                    <Text field="phone3" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { phone3: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="fax"/>
                    </label>
                    <Text field="fax" className="form-control" placeholder="phonePlaceHolder" onChange={( value ) => {  this.setState( { fax: value }) }}/>

                  </FormGroup>
                </div>
              </div>

              <div className="row">

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="facebookName"/>
                    </label>
                    <Text field="facebookName" className="form-control" onChange={( value ) => {  this.setState( { facebookName: value }) }}/>
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="twitterName"/>
                    </label>
                    <Text field="twitterName" className="form-control" onChange={( value ) => {  this.setState( { twitterName: value }) }}/>
                  </FormGroup>
                </div>

              </div>

              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="note"/>
                    </label>
                    <Textarea2 field="note" className="form-control" onChange={( value ) => {  this.setState( { note: value }) }}/>
                  </FormGroup>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

          <div className="row align-items-center mx-0">
            <div className="col-md">
              <h5>
                <Translate id="servicePointData"/>
              </h5>
            </div>
            <div className="col-md-auto d-flex align-items-center">

            </div>
          </div>

          <div className="row mx-0">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="regionCounty"/>
                    </label>
                    <Select
                        field="regionCounty"
                        clearable={false}
                        onChange={( value ) => {
                          //const regionCounty = _.find( regionCounties, { id: value } );
                          //if( regionCounty ) {
                            this.setState( { regionCounty: value }, this.getGeoData )
                          //}
                        }}
                        options={regionCounties}
                        className="form-control"
                        labelKey="locationName"
                        valueKey="locationCode"
                        searchable={true}
                        value={regionCounty}
                      />
                      </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="district"/>
                    </label>
                    <Select
                        field="district"
                        clearable={false}
                        onChange={( value ) => {
                          //const district = _.find( districts, { id: value } );
                          //if( district ) {
                            this.setState( { district: value }, this.getGeoData )
                          //}
                        }}
                        options={districts}
                        className="form-control"
                        labelKey="locationName"
                        valueKey="locationCode"
                        searchable={true}
                        value={district}
                      />

                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="zone"/>
                    </label>
                    <Select
                        field="zone"
                        clearable={false}
                        onChange={( value ) => {
                          //const zone = _.find( zones, { id: value } );
                          //if( zone ) {
                            this.setState( { zone: value }, this.getGeoData )
                          //}
                        }}
                        options={zones}
                        className="form-control"
                        labelKey="locationName"
                        valueKey="locationCode"
                        searchable={true}
                        value={zone}
                      />
                   </FormGroup>
                </div>

              </div>


              <div className="row">

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="community"/>
                    </label>
                    <Select
                        field="community"
                        clearable={false}
                        onChange={( value ) => {
                          //const community = _.find( communities, { id: value } );
                          //if( community ) {
                            this.setState( { community: value }, this.getGeoData )
                          //}
                        }}
                        options={communities}
                        className="form-control"
                        labelKey="locationName"
                        valueKey="locationCode"
                        searchable={true}
                        value={community}
                      />
                      </FormGroup>
                </div>

                <div className="col-md-4">
                  <FormGroup>
                    <label>
                      <Translate id="street"/>
                    </label>
                    <Select
                        field="street"
                        clearable={false}
                        onChange={( value ) => {
                          //const street = _.find( streets, { id: value } );
                          //if( street ) {
                            this.setState( { street: value })
                          //}
                        }}
                        options={streets}
                        className="form-control"
                        labelKey="locationName"
                        valueKey="locationCode"
                        searchable={true}
                        value={street}
                      />
                  </FormGroup>
                </div>

              </div>
              {googleMapKey !=='' &&
              <div className="row">

                <div className="col-md-12">
                    <div  style={{  width: '100%' }} >
                     <GMap 
                        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapKey}`}
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div style={{ height: `385px` }} />}
                        mapElement={<div style={{ height: `100%` }} />}
                        lat={latitude}
                        lng={longitude}
                        defaultZoom={defaultZoom}
                        handleZoom={this.handleZoom}
                        addMarker={this.addMarker}
                     />
                    </div>
                </div>
                <div className="col-md-6">
                  <FormGroup>
                    <label>
                      <Translate id="latitude"/>: {latitude}
                    </label>

                  </FormGroup>
                </div>
                <div className="col-md-6">
                  <FormGroup>
                    <label>
                      <Translate id="longitude"/>: {longitude}
                    </label>

                  </FormGroup>
                </div>

              </div>
              }
            </div>

          </div>
        </div>

          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="newPremise"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseName"/>
                      </label>
                      <Text field="premiseName" className="form-control"  onChange={( value ) => {  this.setState( { premiseName: value }) }}/>
                    </FormGroup>
                  </div>


                </div>

                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseType"/>
                      </label>
                      <Select
                        field="premiseType"
                        clearable={false}
                        onChange={( value ) => {
                         // const premiseType = _.find( premiseTypes, { id: value } );
                          //if( premiseType ) {
                            this.setState( { premiseType: value }, this.getPremiseTypesCategoriesData )
                          //}
                        }}
                        options={premiseTypes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseType}
                      />                    
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseCategory"/>
                      </label>
                      <Select
                        field="premiseCategory"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseCategory = _.find( premiseCategories, { id: value } );
                          //if( premiseCategory ) {
                            this.setState( { premiseCategory: value } )
                          //}
                        }}
                        options={premiseCategories}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseCategory}
                      />    
                      </FormGroup>
                  </div>

                </div>

                <div className="row">

                <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseActivity"/>
                      </label>
                      <Select
                        field="premiseActivity"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseActivity = _.find( premiseActivities, { id: value } );
                          //if( premiseActivity ) {
                            //setValue( value );
                            this.setState( { premiseActivity: value }, this.getSubActivityData )
                          //}
                        }}
                        options={premiseActivities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseActivity}
                      />                     
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseSubActivity"/>
                      </label>
                      <Select
                        field="premiseSubActivity"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseSubActivity = _.find( premiseSubActivities, { id: value } );
                          //if( premiseSubActivity ) {
                            this.setState( { premiseSubActivity: value } )
                          //}
                        }}
                        options={premiseSubActivities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseSubActivity}
                      />                       
                      </FormGroup>
                  </div>
                
                </div>
                <div className="row">

                <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseBuildingType"/>
                      </label>
                      <Select
                        field="premiseBuildingType"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseBuildingType = _.find( premiseBuildingTypes, { id: value } );
                          //if( premiseBuildingType ) {
                            this.setState( { premiseBuildingType: value } )
                          //}
                        }}
                        options={premiseBuildingTypes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseBuildingType}
                      />
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseApplicationCapacity"/>
                      </label>
                      <Select
                        field="premiseApplicationCapacity"
                        clearable={false}
                        onChange={( value ) => {
                          //const premiseApplicationCapacity = _.find( premiseApplicationCapacities, { id: value } );
                          //if( premiseApplicationCapacity ) {
                            this.setState( { premiseApplicationCapacity: value } )
                          //}
                        }}
                        options={premiseApplicationCapacities}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={premiseApplicationCapacity}
                      />
                    </FormGroup>
                  </div>

                </div>

                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premiseLandmark"/>
                      </label>
                      <Textarea2 field="premiseLandmark" className="form-control" value={premiseLandmark} onChange={( value ) => {  this.setState( { premiseLandmark: value }) }}/>
                    </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="premisePoleNumber"/>
                      </label>
                      <Text field="premisePoleNumber" className="form-control" onChange={( value ) => {  this.setState( { premisePoleNumber: value }) }}/>
                    </FormGroup>
                  </div>
                </div>


              </div>

            </div>
          </div>

          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="servicePointDetail"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-12">
  
                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="readingFrecuency"/>
                      </label>
                      <Select
                        field="readingFrecuency"
                        clearable={false}
                        onChange={( value ) => {
                          //const readingFrecuency = _.find( readingFrecuencies, { id: value } );
                          //if( readingFrecuency ) {
                            this.setState( { readingFrecuency: value } )
                          //}
                        }}
                        options={readingFrecuencies}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={readingFrecuency}
                      />
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="phase"/>
                      </label>
                      <Select
                        field="phase"
                        clearable={false}
                        onChange={( value ) => {
                          //const phase = _.find( phases, { id: value } );
                          //if( phase ) {
                            this.setState( { phase: value } )
                          //}
                        }}
                        options={phases}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={phase}
                      />
                      </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <label>
                        <Translate id="voltageLevel"/>
                      </label>
                      <Select
                        field="voltageLevel"
                        clearable={false}
                        onChange={( value ) => {
                          //const voltageLevel = _.find( voltageLevels, { id: value } );
                          //if( voltageLevel ) {
                            this.setState( { voltageLevel: value } )
                          //}
                        }}
                        options={voltageLevels}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={voltageLevel}
                      />
                      </FormGroup>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="accountData"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>

            <div className="row mx-0">
              <div className="col-md-12">
  
                <div className="row">
                  <div className="col-md-2">
                    <FormGroup>
                      <label />
                      
                      <Checkbox field="sendSMS" label={<Translate id="sendSMS"/>}
                          labelStyle={{ width: 'auto' }}/>
                    </FormGroup>
                  </div>
                  <div className="col-md-2">
                    <FormGroup>
                      <label>
                        <Translate id="preferedBillDeliveryMode"/>
                      </label>
                      <Select
                        field="preferedBillDeliveryMode"
                        clearable={false}
                        onChange={( value ) => {
                          //const preferedBillDeliveryMode = _.find( preferedBillDeliveryModes, { id: value } );
                          //if( preferedBillDeliveryMode ) {
                            this.setState( { preferedBillDeliveryMode: value } )
                          //}
                        }}
                        options={preferedBillDeliveryModes}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={preferedBillDeliveryMode}
                      />                    
                      </FormGroup>
                  </div>
                  <div className="col-md-2">
                    <FormGroup>
                      <label>
                        <Translate id="billCopies"/>
                      </label>
                      <Text field="billCopies" className="form-control" onChange={( value ) => {  this.setState( { billCopies: value }) }}/>
                    </FormGroup>
                  </div>
                </div>

               </div>

            </div>
          </div> 

          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="appliances"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>

            <div className="row mx-0" >
                    <div className="col-md-2">
                      <FormGroup>
                      <button type="button"  onClick={this.addAppliance.bind(this)}  className="btn btn-info white"><Translate id="addAppliance"/></button>
                      </FormGroup>
                    </div>
            </div>
            <div className="row mx-0" >
              <div className="col-md-12">
                <table
                  className={classnames( 'table table-striped' )}
                >
                  <thead>
                    <tr>
                      <th width={400} ><Translate id="ApplianceDeviceCode"/></th>
                      <th width={300}><Translate id="ApplianceDevicePower"/></th>
                      <th width={300}> <Translate id="ApplianceDeviceNumber"/></th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>

                  
                    {
                      applianceCollection.map ( (appliance, index )  => {

                        //console.log(appliance)
                        return (
                        <tr key={index}>
                          <td >
                            <FormGroup>

                              <Select
                                clearable={false}
                                options={appliances}
                                className="form-control"
                                labelKey="description"
                                searchable={false}
                                valueKey="deviceCode"
                                onChange={
                                  (value) => this.handleAppliance(value,index,`DeviceCode`) 
                                }
                                value={appliance.DeviceCode }

                              /> 
                              </FormGroup>
                          </td>
                          <td>
                            <FormGroup>

                              <Text 
                                onChange={
                                  (value) => this.handleAppliance(value,index,`DevicePower`) 
                                }
                                className="form-control"
                                value={appliance.DevicePower }
                                
                              />
                            </FormGroup>
                          </td>

                          <td>
                            <FormGroup>
        
                              <Text 
                                className="form-control"
                                onChange={
                                  (value) => this.handleAppliance(value,index,`DeviceNumber`) 
                                }
                                value={appliance.DeviceNumber }

                                />
                            </FormGroup>
                          </td>


                          <td>
                                <button className="btn btn-outline-danger btn-sm" type="button"
                                        onClick={ this.rmAppliance.bind(this,index) }>
                                  <i className="fa fa-trash"/>
                                </button>
                          </td>
                        </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>

          </div> 

          <div className="pb-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 12px' }}>

            <div className="row align-items-center mx-0">
              <div className="col-md">
                <h5>
                  <Translate id="attachments"/>
                </h5>
              </div>
              <div className="col-md-auto d-flex align-items-center">

              </div>
            </div>
            <div className="row mx-0">
              <div className="col-md-12">

                <div className="row">
                  <div className="col-md-2">
                    <FormGroup>
                    <label>
                        <Translate id="documentsGroup"/>*
                    </label>
                    <Select
                        field="documentsGroupId"
                        clearable={false}
                        onChange={( value ) => {
                          //const preferedBillDeliveryMode = _.find( preferedBillDeliveryModes, { id: value } );
                          //if( preferedBillDeliveryMode ) {
                            this.setState( { documentsGroupId: value } )
                          //}
                        }}
                        options={documentsGroup}
                        className="form-control"
                        labelKey="description"
                        searchable={true}
                        value={documentsGroupId}
                      />                    
                    </FormGroup>
                  </div>
                  <div className="col-md-2">

                  </div>
                  <div className="col-md-2">

                  </div>
                </div>
              </div>

            </div>
            
            <div className="row mx-0">
              <div className="col-md-6">
                {documentsGroupId===1 &&
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="nationalID"/>*
                    </label>
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                        {(errorUpload["CD001"] || !this.state.fileNationalId) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    // console.log("test");
                                    setValue( 'fileNationalId', getValue( 'fileNationalId' ) ? getValue( 'fileNationalId' )  : files )
                                    this.setState({fileNationalId : getValue( 'fileNationalId' ) ? getValue( 'fileNationalId' )  : files})
                                    this.sendFileMessage( "CD001", files[0] );

                                  
                                };
                                reader.readAsDataURL( files[0] );

                              }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }
                        
                          {!errorUpload["CD001"] && _.map( this.state.fileNationalId, ( file, index ) => {
                              return <div key={index}
                                          className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                                {file.name}
                                <i className="fa icon-close pointer"
                                  onClick={() => { removeValue( 'fileNationalId', index ); this.setState({fileNationalId: null})  } }/>
                              </div>
                            }
                          )}
                        
                      </FormGroup>
                  </div>

                </div>
                }
                {documentsGroupId===1 &&
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="proofOfOwnership"/>*
                    </label>
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                        {(errorUpload["CD017"] || !this.state.fileProofOfOwnership) &&
                        <Dropzone
                          className={classnames( 'd-inline', { disabled: false } )}
                          accept="application/pdf, .doc, .docx, image/*" disabled={false}
                          maxSize={1000000}
                          maxFiles={1}
                          onDrop={( files ) => {
                            if( files && files[0] ) {
                              const reader = new FileReader();
                              reader.onload = () => {
                                  this.sendFileMessage( "CD017", files[0] ) 
                                  setValue( 'fileProofOfOwnership', getValue( 'fileProofOfOwnership' ) ? getValue( 'fileProofOfOwnership' )  : files )
                                  this.setState({fileProofOfOwnership : getValue( 'fileProofOfOwnership' ) ? getValue( 'fileProofOfOwnership' )  : files})
                                
                              };
                              reader.readAsDataURL( files[0] );
                              
                            }
                          }}
                          >
                          <i className="fa fa-paperclip mr-1"/>
                          <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                        </Dropzone>
                      }
                      {!errorUpload["CD017"] && _.map( this.state.fileProofOfOwnership, ( file, index ) => {
                          return <div key={index}
                                      className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                            {file.name}
                            <i className="fa icon-close pointer"
                              onClick={() => { removeValue( 'fileProofOfOwnership', index ); this.setState({fileProofOfOwnership: null})  } }/>
                          </div>
                        }
                      )} 
                    </FormGroup>
                  </div>

                </div>
                }

                {documentsGroupId===2 &&
                  <div className="row">
                    <div className="col-md-6">
                      <FormGroup>
                      <label>
                          <Translate id="TaxIdentification"/>*
                      </label>
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        {(errorUpload["CD007"] || !this.state.fileTaxIdentification) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                   this.sendFileMessage( "CD007", files[0] ) 
                                    setValue( 'fileTaxIdentification', getValue( 'fileTaxIdentification' ) ? getValue( 'fileTaxIdentification' )  : files )
                                    this.setState({fileTaxIdentification : getValue( 'fileTaxIdentification' ) ? getValue( 'fileTaxIdentification' )  : files})
                                 
                                };
                                reader.readAsDataURL( files[0] );

                              }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }
                        {!errorUpload["CD007"] && _.map( this.state.fileTaxIdentification, ( file, index ) => {
                            return <div key={index}
                                        className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                              {file.name}
                              <i className="fa icon-close pointer"
                                onClick={() => { removeValue( 'fileTaxIdentification', index ); this.setState({fileTaxIdentification: null})  } }/>
                            </div>
                          }
                        )} 
                      </FormGroup>
                    </div>

                  </div>
                }

                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="sketchMap"/>
                    </label>                      

                    </FormGroup>
                  </div>
                  <div className="col-md-6">
     
                      <FormGroup>
                        {(errorUpload["CD018"] || !this.state.fileSketchMap) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    this.sendFileMessage( "CD018", files[0] ) 
                                    setValue( 'fileSketchMap', getValue( 'fileSketchMap' ) ? getValue( 'fileSketchMap' )  : files )
                                    this.setState({fileSketchMap : getValue( 'fileSketchMap' ) ? getValue( 'fileSketchMap' )  : files})
                                  

                                };
                                reader.readAsDataURL( files[0] );


                              }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }

                        {!errorUpload["CD018"] && _.map( this.state.fileSketchMap, ( file, index ) => {
                            return <div key={index}
                                        className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                              {file.name}
                              <i className="fa icon-close pointer"
                                onClick={() => { removeValue( 'fileSketchMap', index ); this.setState({fileSketchMap: null})  } }/>
                            </div>
                          }
                        )} 
                      </FormGroup>
                  </div>

                </div>

                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                    <label>
                        <Translate id="annualDemandDeclaration"/>
                    </label>                      

                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                      <FormGroup>
                        {(errorUpload["CD019"] || !this.state.fileAnnualDemandDeclaration) &&
                          <Dropzone
                            className={classnames( 'd-inline', { disabled: false } )}
                            accept="application/pdf, .doc, .docx, image/*" disabled={false}
                            maxSize={1000000}
                            maxFiles={1}
                            onDrop={( files ) => {
                              if( files && files[0] ) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    this.sendFileMessage( "CD019", files[0] ) 
                                    setValue( 'fileAnnualDemandDeclaration', getValue( 'fileAnnualDemandDeclaration' ) ? getValue( 'fileAnnualDemandDeclaration' )  : files )
                                    this.setState({fileAnnualDemandDeclaration : getValue( 'fileAnnualDemandDeclaration' ) ? getValue( 'fileAnnualDemandDeclaration' )  : files})
 
                                  
                                };
                                reader.readAsDataURL( files[0] );

                             }
                            }}
                            >
                            <i className="fa fa-paperclip mr-1"/>
                            <span className="color-gray-4 pointer font-weight-light"><Translate id="addAttachment"/></span>
                          </Dropzone>
                        }

                        {!errorUpload["CD019"] && _.map( this.state.fileAnnualDemandDeclaration, ( file, index ) => {
                            return <div key={index}
                                        className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                              {file.name}
                              <i className="fa icon-close pointer"
                                onClick={() => { removeValue( 'fileAnnualDemandDeclaration', index ); this.setState({fileAnnualDemandDeclaration: null})  } }/>
                            </div>
                          }
                        )} 
                        </FormGroup>
                  </div>
 
                </div>

              </div>

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                    <b>Important Information!</b>
                    <p>
                    Please ensure that you have the required mandatory document(s) below:
                      <ol> 
                        <li>PROOF OF OWNERSHIP</li>
                        <li>PERSONAL IDENTITY DOCUMENT</li>
                        <li>or TAX IDENTIFICATION NUMBER.</li>
                      </ol>
                    </p>

                  </div>
                </div>
              </div>

            </div>
          </div> 
          
          <div className="text-center pt-3">
                <button className="btn btn-info" ><Translate id="submit"/></button>
          </div>
        </form>
      }
      </Form>

      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCodes: state.settings.externalCodes,
  googleMapKey: state.settings.googleMapKey,
  uploadFile: state.settings.uploadFile,
  externalApiUrl: state.settings.externalApiUrl,
} );


const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );
export default injectIntl( connect( mapStateToProps, mapDispatchToProps )( WorkRequest ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/WorkRequest/index.js